// extracted by mini-css-extract-plugin
module.exports = {"container":"resultDetails_container__EEpNM"};